import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import './engage.css';
import { insta, facebook, snapchat, linked } from "../../../assets/index.js";

const Engagements = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false); // Track login status

  const statsData = [
    { title: 'Budget', icon: 'bi-credit-card', value: Math.floor(Math.random() * 1000) + 500, percentageChange: 13, changeClass: 'success', color: "bg-primary-light" },
    { title: 'New projects', icon: 'bi-people', value: Math.floor(Math.random() * 1000) + 500, percentageChange: 7, changeClass: 'warning', color: "bg-success-light" },
    { title: 'Total hours', icon: 'bi-clock-history', value: Math.floor(Math.random() * 1000) + 500, percentageChange: 5, changeClass: 'danger', color: "bg-warning-light" },
    { title: 'Work load', icon: 'bi-minecart-loaded', value: Math.floor(Math.random() * 1000) + 500, percentageChange: 20, changeClass: 'success', color: "bg-info-light" },
  ];

  const tableData = [
    { name: 'Darlene Robertson', date: 'Apr 15, 2021', app: facebook, appName: 'Facebook', activity: '$2.750', meetingStatus: 'Postponed', meetingStatusClass: 'bg-warning' },
    { name: 'Theresa Webb', date: 'Mar 20, 2021', app: insta, appName: 'Instagram', activity: '$4.200', meetingStatus: 'Scheduled', meetingStatusClass: 'bg-success' },
    { name: 'Theresa Webb', date: 'Mar 20, 2021', app: snapchat, appName: 'Instagram', activity: '$4.200', meetingStatus: 'Scheduled', meetingStatusClass: 'bg-success' },
    { name: 'Theresa Webb', date: 'Mar 20, 2021', app: linked, appName: 'Instagram', activity: '$4.200', meetingStatus: 'Postponed', meetingStatusClass: 'bg-warning' },
  ];

  useEffect(() => {
    // Example check for login status (replace with your actual check logic)
    const userToken = true;
    if (userToken) {
      setIsLoggedIn(true); 
    } else {
      setIsLoggedIn(false); 
    }
  }, []);

  if (!isLoggedIn) {
    return (
      <div className="text-center ">
        <div className="alert alert-warning background-dark p-5" role="alert">
          <h4 className="alert-heading landing-text-white">You need to log in!</h4>
          <p className="landing-text-white"> Please log in to view your Engagement Dashboard.</p>
          <div className="d-flex justify-content-center">
            <button className="btn btn-primary m-2" onClick={() => window.location.href = "/dashboard"}>
              Log in
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <main className="py-6 bg-surface-secondary">
        <div className="container-fluid">
          <div className="row g-4 mb-6">
            {statsData.map((item, index) => (
              <div key={index} className="col-xl-3 col-lg-4 col-md-6 col-12 ">
                <div className={`card shadow border-0 ${item.color}`}>
                  <div className="card-body p-4 ">
                    <div className="row">
                      <div className="col">
                        <span className="h6 font-semibold text-muted text-sm d-block mb-2">{item.title}</span>
                        <span className="h3 font-bold mb-0">${item.value}</span>
                      </div>
                      <div className="col-auto">
                        <div className="icon icon-shape bg-tertiary text-white text-lg rounded-circle">
                          <i className={`bi text-muted fs-3 ${item.icon}`}></i>
                        </div>
                      </div>
                    </div>
                    <div className="mt-2 mb-0 text-sm ">
                      <span className={`badge badge-pill bg-soft-${item.changeClass} text-${item.changeClass} me-2`}>
                        <i className={`bi bi-arrow-up me-1`}></i>{item.percentageChange}%
                      </span>
                      <span className="text-nowrap text-xs text-muted">Since last month</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="card shadow border-0 mb-7 mt-5">
            <div className="card-header">
              <h5 className="mb-0">Applications</h5>
            </div>
            <div className="table-responsive ">
              <table className="table table-hover table-nowrap">
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Name</th>
                    <th scope="col">Date</th>
                    <th scope="col">Social App</th>
                    <th scope="col">Activity</th>
                    <th scope="col">Meeting</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((entry, index) => (
                    <tr key={index}>
                      <td>
                        <img
                          alt="..."
                          src="https://images.unsplash.com/photo-1610271340738-726e199f0258?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=3&w=256&h=256&q=80"
                          className="avatar avatar-sm rounded-circle me-2 engage-image"
                        />
                        <Link className="text-heading font-semibold" to="#">
                          {entry.name}
                        </Link>
                      </td>
                      <td>{entry.date}</td>
                      <td>
                        <img alt="..." className="img-width" src={entry.app} />
                      </td>
                      <td>{entry.activity}</td>
                      <td>
                        <span className={`badge badge-lg badge-dot ${entry.meetingStatusClass}`}>
                          <i className={`bg-${entry.meetingStatusClass}`}></i>{entry.meetingStatus}
                        </span>
                      </td>
                      <td className="text-end">
                        <button type="button" className="btn btn-sm btn-square btn-neutral text-danger-hover">
                          <i className="bi bi-trash"></i>
                        </button>
                      </td>
                    </tr>

                  ))}
                </tbody>
              </table>
            </div>
            <div className="card-footer border-0 py-5">
              <span className="text-muted text-sm">Showing 10 items out of 250 results found</span>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Engagements;
